
import { Component, Mixins } from "vue-property-decorator";
import { IEditBehavior } from "../../../../../../documaker/domain/format/objects";
import { IEditBehaviorPropertyEditable, instanceOfIEditBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class EditBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IEditBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IEditBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isEditBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfIEditBehaviorPropertyEditable(s) && s.editBehavior().isEditable(), false);
  }

  get editBehavior(): IEditBehavior {
    return this.readPropertyOrDefault(s => s.editBehavior().getValue(), { isVisible: false });
  }

  set editBehavior(value: IEditBehavior) {
    this.writePropertyWhenValid(s => s.editBehavior().setValue(value));
  }
}
